import { Breadcrumb } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import HomeBreadcrumb from "./components/HomeBreadcrumb.component";
import LinkBreadcrumb from "./components/LinkBreadcrumb.component";
import TextBreadcrumb from "./components/TextBreadcrumb.component";
import {
  setCurrentPath,
  getSplitPath,
  validBreadcrumb,
  displayEcrBreadcrumb,
  displayHomeBreadcrumb,
  breadcrumbIsLink,
} from "./utils/Breadcrumb.functions";

const MemberBreadcrumbs = () => {
  const location = useLocation();
  setCurrentPath(location.pathname);

  return (
    <>
      {displayEcrBreadcrumb() && <></>}
      {!displayEcrBreadcrumb() && (
        <Breadcrumb>
          {getSplitPath().map((name, index) => {
            if (displayHomeBreadcrumb(index)) {
              return <HomeBreadcrumb key={`${index}`} />;
            } else if (validBreadcrumb(index)) {
              if (breadcrumbIsLink(index)) {
                return (
                  <LinkBreadcrumb
                    key={`${index}`}
                    currentIndex={index}
                    currentName={name}
                  />
                );
              } else {
                return <TextBreadcrumb key={`${index}`} currentName={name} />;
              }
            } else return <></>;
          })}
        </Breadcrumb>
      )}
    </>
  );
};

export default MemberBreadcrumbs;
